import { Flow } from 'signup-constants/Flow';
import { SignupEmbedder } from 'signup-embedder';
import { getIntentLink } from '../intents/intentSelectors';
import { getIsPostVerification } from '../routing/getIsPostVerification';
import { getCountryCode } from '../store/app/selectors';
import { getIsMobile } from '../utils/deviceUtils';
import { isFlow } from '../utils/isFlow';
import { hasEnrolmentQueryParamForAcq129, isUserFromPricingPage } from './acq129/acq129Utils';
import { getIsUserFromFreeCrmPage } from './acq135/acq135Utils';
import { enrollOnFlow } from './experimentDefaults';
import { ExperimentKeys, TEST_KEY } from './ExperimentKeys';
import { getIsNewUserExperiment } from './ExperimentUtils';
export const EXPERIMENT_ID = 'experimentId';
const SEEN_EXPERIMENTS = new Set();
const Experiments = new Map([[ExperimentKeys.ACQ129, {
  shouldEnroll: state => {
    const isNewUser = getIsNewUserExperiment(state);
    const isCorrectFlowToEnrollOn = isFlow([Flow.Crm, Flow.Marketing, Flow.Sales, Flow.Service]);
    const isOnTrialFlowAfterEnrolment = isFlow(Flow.Trial) && hasEnrolmentQueryParamForAcq129();
    const isOnPurchaseFlowAfterEnrolment = isFlow(Flow.Purchase) && hasEnrolmentQueryParamForAcq129();
    const isCorrectFlow = isCorrectFlowToEnrollOn || isOnTrialFlowAfterEnrolment || isOnPurchaseFlowAfterEnrolment;
    const hasSeenPricingPage = isUserFromPricingPage();
    const isMobile = getIsMobile();
    const isEmbedded = SignupEmbedder.isActive();
    const hasIntent = Boolean(getIntentLink(state));
    const country = getCountryCode(state);
    const isSeatsCountry = country && country.toLowerCase() === 'au';
    const isPostVerification = getIsPostVerification();
    const shouldEnrollAcq129 = isNewUser && isCorrectFlow && !hasSeenPricingPage && !isMobile && !isEmbedded && !hasIntent && !isSeatsCountry && !isPostVerification;
    return shouldEnrollAcq129;
  }
}], [ExperimentKeys.ACQ130, {
  shouldEnroll: state => {
    const isEnrolledFlow = isFlow([Flow.Crm, Flow.Marketing, Flow.Sales, Flow.Service]);
    const isNewUser = getIsNewUserExperiment(state);
    const isUserFromFreeCrmPage = getIsUserFromFreeCrmPage();
    return isEnrolledFlow && isNewUser && !isUserFromFreeCrmPage;
  }
}], [ExperimentKeys.ACQ131, {
  shouldEnroll: state => {
    const isEnrolledFlow = isFlow([Flow.Crm, Flow.Marketing, Flow.Sales, Flow.Service]);
    const isNewUser = getIsNewUserExperiment(state);
    const isUserFromFreeCrmPage = getIsUserFromFreeCrmPage();
    return isEnrolledFlow && isNewUser && !isUserFromFreeCrmPage;
  }
}], [ExperimentKeys.BIAB004, {
  shouldEnroll: state => {
    return isFlow(Flow.Crm) && !getIntentLink(state);
  }
}], [ExperimentKeys.ACQ128, {
  shouldEnroll: state => {
    const isEnrolledFlow = isFlow([Flow.Crm, Flow.Marketing, Flow.Sales, Flow.Service]);
    const isNewUser = getIsNewUserExperiment(state); // TODO: Include !isUserFromFreeCrmPage once it is merged

    return isEnrolledFlow && isNewUser;
  }
}]]);
export const getExperiment = id => {
  // we want to prefer this solution over mocking getExperiment so that the
  // seen experiments tracking below continues to work and doesn't get
  // accidentally mocked
  if (id === TEST_KEY) {
    return {
      shouldEnroll: () => enrollOnFlow([Flow.Crm])
    };
  }

  SEEN_EXPERIMENTS.add(id);
  return Experiments.get(id);
};
export function getSeenExperimentsForTesting() {
  return Array.from(SEEN_EXPERIMENTS);
}